import { AutocompleteOption } from '../models/autocompleteOption';

export const generateYearOptions = (): AutocompleteOption[] => {
  const currentYear = new Date().getFullYear();
  const minYear = 1999;
  const years: AutocompleteOption[] = [];
  for (let i = currentYear; i > minYear; i--) {
    years.push({ label: `${i}`, id: `${i}` });
  }

  return years;
};
